<template>
	<el-dialog v-if="show" @close="handleClose" :title="detail.type + '办理'" :visible.sync="show" width="80%">
		<el-descriptions size="mini" class="margin-top" title="基本信息" border>
			<template slot="extra">
				<el-button @click="xiazai" type="primary" size="small">下载申请表</el-button>
			</template>
			<el-descriptions-item>
				<template slot="label">
					<i class="el-icon-user"></i>
					办理人姓名
				</template>
				{{ biao.name }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					<i class="el-icon-postcard"></i>
					身份证号
				</template>
				{{ biao.idcard }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					<i class="el-icon-mobile-phone"></i>
					手机号
				</template>
				{{ biao.phone ? biao.phone : detail.phone }}
			</el-descriptions-item>

			<el-descriptions-item>
				<template slot="label">
					<i class="el-icon-location-outline"></i>
					户籍地
				</template>
				<span v-for="(p, i) in biao.huji_json" :key="i"> {{ p.name }}</span>
				<span>{{ biao.huji_address }}</span>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.xianju_json && biao.xianju_json.length > 0">
				<template slot="label">
					<i class="el-icon-office-building"></i>
					现居地
				</template>
				<div v-if="biao.xianju_json == ''">
					<span v-for="(p, i) in biao.huji_json" :key="i"> {{ p.name }}</span>
					<span>{{ biao.huji_address }}</span>
				</div>
				<div v-else>
					<span v-for="(p, i) in biao.xianju_json" :key="i"> {{ p.name }}</span>
					<span>{{ biao.xianju_address }}</span>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.jh_name">
				<template slot="label">
					<i class="el-icon-user"></i>
					监护人姓名
				</template>
				{{ biao.jh_name }}
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.jh_idcard">
				<template slot="label">
					<i class="el-icon-user"></i>
					监护人身份证
				</template>
				{{ biao.jh_idcard }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					<i class="el-icon-date"></i>
					申请时间
				</template>
				{{ biao.ins_date }}
			</el-descriptions-item>
			<el-descriptions-item>
				<template slot="label">
					来自
				</template>
				微信小程序
			</el-descriptions-item>
			<el-descriptions-item v-if="detail.shenhe_content">
				<template slot="label">
					审核意见
				</template>
				{{detail.shenhe_content }}
			</el-descriptions-item v-if="role=='371100000000'">
				<el-descriptions-item >
				<template slot="label">
					市级确认
				</template>
		
				<el-tag @click="zxshenhe" v-if="detail.beizhu=='已确认'?'success':'danger'">{{ detail.beizhu=='已确认'?'已确认':'点击确认' }}</el-tag>
			</el-descriptions-item>	
			<el-descriptions-item v-if="biao.daili_name">
				<template slot="label">
					代办人姓名
				</template>
				{{ biao.daili_name }}
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.daili_phone">
				<template slot="label">
					代办人手机号
				</template>
				{{ biao.daili_phone }}
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.daili_idcard">
				<template slot="label">
					代办人身份证
				</template>
				{{ biao.daili_idcard }}
			</el-descriptions-item>	
		
		</el-descriptions>
		<asdkf v-if="detail.type == '儿童康复救助'" :biao="biao"></asdkf>
		<asdcjz v-if="detail.type == '残疾人证'" :biao="biao"></asdcjz>
		<asdkfew v-if="detail.type == '人工耳蜗救助'" :biao="biao"></asdkfew>
		<asdfzqj v-if="detail.type == '辅助器具'" :biao="biao"></asdfzqj>
		<asdqiuzhi v-if="detail.type == '求职需求咨询'" :biao="biao"></asdqiuzhi>
		<asdkfss v-if="detail.type == '儿童肢残矫治手术'" :biao="biao"></asdkfss>
		<asdpeixun v-if="detail.type == '就业技能培训'" :biao="biao"></asdpeixun>
		<asdzhuxue v-if="detail.type == '励志助学'" :biao="biao"></asdzhuxue>
		<asdwccp v-if="detail.type == '文创产品推广'" :biao="biao"></asdwccp>
		<el-descriptions :column="1" style="margin-top: 20px;margin-bottom: 20px;" size="mini" class="margin-top"
			title="证明材料" border>
			<el-descriptions-item v-if="biao.avatar">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					申请人照片
				</template>
				<div v-if="biao.avatar">
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.avatar" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.img1">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					图片1
				</template>
				<div v-if="biao.img1">
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.img1" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.img2">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					图片2
				</template>
				<div v-if="biao.img2">
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.img2" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.yixuezhengming">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					医学诊断证明
				</template>
				<div>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.yixuezhengming" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
				<el-descriptions-item v-if="biao.pinggu">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					评估报告
				</template>
				<div>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.pinggu" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.idcardf">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					身份证<span v-if="biao.idcardf.length == 0">(无证明系统)</span><span v-else>正面</span>
				</template>
				<div v-if="biao.idcardf && biao.idcardf.length == 0">
					<div v-if="biao.idcardz.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
					<el-button v-else @click="openpdf($url + biao.idcardz[0].path)" type="primary" size="mini">查看证明
					</el-button>
				</div>
				<div v-else>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.idcardz" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.idcardf && biao.idcardf.length > 0">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					身份证反面
				</template>
				<div>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.idcardf" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.jianhu_idcardf">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					监护人身份证<span v-if="biao.jianhu_idcardf.length == 0">(无证明系统)</span><span v-else>正面</span>
				</template>
				<div v-if="biao.jianhu_idcardf && biao.jianhu_idcardf.length == 0">
					<div v-if="biao.jianhu_idcardz.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
					<el-button v-else @click="openpdf($url + biao.jianhu_idcardz[0].path)" type="primary" size="mini">查看证明
					</el-button>
				</div>
				<div v-else>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.jianhu_idcardz" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.jianhu_idcardf && biao.jianhu_idcardf.length > 0">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					身份证反面
				</template>
				<div>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.jianhu_idcardf" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.hukouben1">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					户口本<span v-if="biao.hukouben3.length == 0">(无证明系统)</span><span v-else>索引页</span>
				</template>
				<div v-if="biao.hukouben3.length == 0">
					<div v-if="biao.hukouben1.length == 0">没有上传身份证相关信息</div>
					<el-button v-else type="primary" size="mini" @click="openpdf($url + biao.hukouben1[0].path)">查看证明
					</el-button>
				</div>
				<div v-else>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.hukouben1" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.hukouben">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					户口本<span v-if="biao.hukouben3.length == 0">(无证明系统)</span><span v-else>索引页</span>
				</template>
				<div v-if="biao.hukouben3.length == 0">
					<div v-if="biao.hukouben.length == 0">没有上传残疾人证信息，请在中残联系统验证</div>
					<el-button v-else type="primary" size="mini" @click="openpdf($url + biao.hukouben[0].path)">查看证明
					</el-button>
				</div>
				<div v-else>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.hukouben" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.hukouben2 && biao.hukouben2.length > 0">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					户口本<span v-if="biao.hukouben3.length == 0">(无证明系统)</span><span v-else>户主页</span>
				</template>
				<div v-if="biao.hukouben2.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.hukouben2" :key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.hukouben3 && biao.hukouben3.length > 0">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					户口本<span v-if="biao.hukouben3.length == 0">(无证明系统)</span><span v-else>孩子本人页</span>
				</template>
				<div v-if="biao.hukouben3.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.hukouben3" :key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.juzhuzhengming && waidi">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					居住证明正面
				</template>
				<div v-if="biao.juzhuzhengming.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.juzhuzhengming"
						:key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
<!-- 居住证反面 -->
<el-descriptions-item v-if="biao.juzhuzhengming2 && waidi">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					居住证明反面
				</template>
				<div v-if="biao.juzhuzhengming2.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.juzhuzhengming2"
						:key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
<!-- 居住证反面 -->
<!-- 社保证明 -->
			<el-descriptions-item v-if="biao.shebaozhengming && waidi">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					社保证明
				</template>
				<div v-if="biao.shebaozhengming.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.shebaozhengming"
						:key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<!-- 社保证明 -->
			<!-- 纳税证明 -->
			<el-descriptions-item v-if="biao.nashuizhengming && waidi">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					纳税证明
				</template>
				<div v-if="biao.nashuizhengming.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.nashuizhengming"
						:key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<!-- 纳税证明 -->
			<el-descriptions-item v-if="biao.cjcard">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					残疾人证证明
				</template>
				<div v-if="biao.cjcard.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.cjcard" :key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<!-- 其他证明材料 -->
			<el-descriptions-item v-if="biao.hukouben4">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					其他证明材料
				</template>
				<div>
					<el-image :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
						v-for="(item, index) in biao.hukouben4" :key="index" :src="$url + item.path">
						<div slot="placeholder" class="image-slot">
							<i class="el-icon-loading"></i>
						</div>
					</el-image>
				</div>
			</el-descriptions-item>
			/* */
			
/**/ */
			

			<el-descriptions-item v-if="biao.yhcardz">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					银行卡证明
				</template>
				<div v-if="biao.yhcardz.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.yhcardz" :key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<el-descriptions-item v-if="biao.xuexiaozhengming">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					学历证明
				</template>
				<div v-if="biao.xuexiaozhengming.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.xuexiaozhengming"
						:key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
				<el-descriptions-item v-if="biao.xuexiaozhengming2">
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					在读证明
				</template>
				<div v-if="biao.xuexiaozhengming2.length == 0">没有获取到无证明，请在无证明系统中或残联系统中验证</div>
				<div v-else>
					<div style="display: flex;align-items: center;" v-for="(item, index) in biao.xuexiaozhengming2"
						:key="index">
						<el-button v-if="item.path.indexOf('.pdf') >= 0" type="primary" size="mini"
							@click="openpdf($url + item.path)">查看证明
						</el-button>
						<el-image v-else :preview-src-list="[$url + item.path]" fit="scale-down" style='width: 100px;'
							:src="$url + item.path">
							<div slot="placeholder" class="image-slot">
								<i class="el-icon-loading"></i>
							</div>
						</el-image>
					</div>
				</div>
			</el-descriptions-item>
			<!-- <el-descriptions-item>
				<template slot="label">
					<i class="el-icon-notebook-2"></i>
					<text style="color: red;">*</text> 康复救助时间
				</template>
				<div v-if="0 == 0">
					<div>请选择康复救助时间：</div>
				</div>
				<el-date-picker v-model="zdtime"  type="date" placeholder="选择日期" class="rbtn" style="width: 10vw;"
						@change="handleYearChange" >
					</el-date-picker>
			</el-descriptions-item> -->
		</el-descriptions>
		<span slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;align-items: center;">
			<el-button type="danger" @click="changestatus(3, '驳回')">驳回</el-button>
			<div>
				<el-button @click="handleClose">取 消</el-button>
				<el-button v-if="detail.status != 1 && detail.status != 2" type="success" @click="changestatus(1, '通过')">通过
				</el-button>
				<el-button v-if="detail.status != 2" type="primary" @click="changestatus(2, '归档')">归档</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import asdkf from "./asdthings/asdkf.vue";
import asdcjz from "./asdthings/asdcjz.vue";
import asdkfew from "./asdthings/asdkfew.vue";
import asdfzqj from "./asdthings/asdfzqj.vue";
import asdqiuzhi from "./asdthings/asdqiuzhi.vue";
import asdkfss from "./asdthings/asdkfss.vue";
import asdpeixun from "./asdthings/asdpeixun.vue";
import asdzhuxue from "./asdthings/asdzhuxue.vue";
import asdwccp from "./asdthings/asdwccp.vue";
import vueshowpdf from "vueshowpdf";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      zdtime: "",
      show: false,
      biao: {},
      hukoubenNums: 1,
    };
  },
  components: {
    asdkf,
    asdcjz,
    asdfzqj,
    pdf,
    asdkfew,
    asdqiuzhi,
    asdkfss,
    asdpeixun,
    asdzhuxue,
    asdwccp,
  },
  computed: {
    role() {
      let role = window.localStorage.getItem("org");
      return JSON.parse(role).area;
    },
    waidi() {
      try {
        return this.biao.huji_json[0].id != this.biao.xianju_json[0].id;
      } catch {
        return false;
      }
    },
    test() {
      return this.detail.jh_name;
    },
    info() {
      let info = window.localStorage.getItem("info");
      return JSON.parse(info);
    },
    org() {
      let org = window.localStorage.getItem("org");
      return JSON.parse(org);
    },
  },
  watch: {
    value() {
      if (this.show != this.value) {
        this.show = this.value;
        this.$emit("input", this.show);
      }
    },
    async detail() {
      await this.getbiao();
    },
  },
  methods: {
    async zxshenhe() {
      let row = this.detail;
      let y = await axios.get(this.$url + "admin/beizhugai", {
        params: {
          token: this.info.uid,
          id: row.id,
          beizhu: "已确认",
        },
      });
      this.$message({
        type: "success",
        message: `审核成功!`,
      });
      row.guidang = false;
      this.show = false;
      this.$emit("input", false);
      this.$parent.getonethings();
    },
    async handleYearChange(year) {
      this.zdtime = year;
    },
    async changestatus(status, tx) {
      let row = this.detail;
      let inputValue =
        status == 1
          ? "同意,已联系申请人"
          : status == 2
          ? "已归档"
          : "不同意,已驳回";
      // if(this.zdtime.length!=0){
      let ans = await this.$prompt(
        `请输入${tx}意见`,
        `确实要${tx}${row.show_name}的${row.shixiang}吗?`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue,
          type: "warning",
        }
      ).catch(() => {
        row.guidang = false;
      });
      if (!ans) {
        row.guidang = false;
        return;
      }
      let y = await axios.post(this.$url + "admin/changestatus", {
        token: this.info.uid,
        status: status,
        id: row.id,
        content: ans.value,
        dept: this.org.name,
      });
      this.$message({
        type: "success",
        message: `${tx}成功!`,
      });
      row.guidang = false;
      this.show = false;
      this.$emit("input", false);
      this.$parent.getonethings();
    },
    openpdf(url) {
      window.open(url);
    },
    getNumPages(url) {
      url = this.$url + url;
      var loadingTask = pdf.createLoadingTask(url);
      loadingTask.promise
        .then((pdf) => {
          this.hukoubenNums = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf加载失败");
        });
    },
    xiazai() {
      let params = {
        biao: this.biao,
        detail: this.detail,
      };
      window.localStorage.setItem("kf", JSON.stringify(params));
      if (this.detail.type == "儿童康复救助") {
        let routeData = this.$router.resolve({
          path: `/kfprint`,
          query: params,
        });
        window.open(routeData.location.path, "_blank");
        return;
      }
      this.$alert("该功能正在开发中", "尚未开放", {
        confirmButtonText: "确定",
        callback: (action) => {},
      });
    },
    handleClose() {
      this.show = false;
      this.$emit("input", false);
    },
    async getbiao() {
      if (!this.detail.yewu_id || !this.detail.type) {
        return;
      }
      let ans = await axios.get(this.$url + "admin/onedetail", {
        params: {
          token: this.info.uid,
          yewu_id: this.detail.yewu_id,
          type: this.detail.type,
        },
      });

      console.log(ans, "ans");
      this.biao = JSON.parse(JSON.stringify(ans.data.detail));
      if (this.biao.ins_date) {
        this.biao.ins_date = new Date(this.biao.ins_date).toLocaleString();
      }
      console.log(this.biao, "console.log(this.biao);");
    },
  },
  props: ["value", "detail"],
  async created() {
    this.show = this.value;
  },
};
</script>

<style>
.image-slot {
  font-size: 50px;
}
</style>
